<template>
  <v-card outlined class="search-filters pa-4">
    <div class="d-flex align-center justify-space-between mb-3">
      <h3 class="text-subtitle-1 font-weight-bold theme-heading">
        Filters
      </h3>
      <v-btn x-small text color="#EF4444" @click="$emit('clear-filters')">
        <v-icon x-small left>mdi-filter-remove</v-icon>
        Clear
      </v-btn>
    </div>

    <v-select
      v-model="localFilters.seniority"
      :items="availableSeniorities"
      label="Seniority Level"
      dense
      outlined
      clearable
      multiple
      small-chips
      deletable-chips
      hide-details
      class="mb-3"
      color="#007AFF"
      @change="emitUpdate"
    />

    <v-select
      v-model="localFilters.cluster"
      :items="availableClusters"
      label="Specialist Cluster"
      dense
      outlined
      clearable
      multiple
      small-chips
      deletable-chips
      hide-details
      class="mb-3"
      color="#007AFF"
      @change="emitUpdate"
    />

    <v-select
      v-model="localFilters.area"
      :items="availableAreas"
      label="Functional Area"
      dense
      outlined
      clearable
      multiple
      small-chips
      deletable-chips
      hide-details
      class="mb-3"
      color="#007AFF"
      @change="emitUpdate"
    />

    <div class="mb-3">
      <div class="text-caption theme-text-secondary mb-1">
        Minimum Score: {{ localFilters.minScore }}%
      </div>
      <v-slider
        v-model="localFilters.minScore"
        :min="0"
        :max="100"
        :step="5"
        color="#007AFF"
        :track-color="$vuetify.theme.dark ? '#555' : '#E0E0E0'"
        thumb-label
        hide-details
        @change="emitUpdate"
      />
    </div>

    <v-combobox
      v-model="localFilters.skills"
      label="Filter by Skills"
      dense
      outlined
      multiple
      small-chips
      deletable-chips
      hide-details
      color="#007AFF"
      @change="emitUpdate"
    />
  </v-card>
</template>

<script>
export default {
  name: "SearchFilters",
  props: {
    availableSeniorities: {
      type: Array,
      default: () => [],
    },
    availableClusters: {
      type: Array,
      default: () => [],
    },
    availableAreas: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: Object,
      default: () => ({
        seniority: [],
        cluster: [],
        area: [],
        minScore: 0,
        skills: [],
      }),
    },
  },
  data() {
    return {
      localFilters: {
        seniority: this.filters.seniority || [],
        cluster: this.filters.cluster || [],
        area: this.filters.area || [],
        minScore: this.filters.minScore || 0,
        skills: this.filters.skills ? [...this.filters.skills] : [],
      },
    };
  },
  watch: {
    filters: {
      deep: true,
      handler(newVal) {
        this.localFilters = {
          seniority: newVal.seniority || [],
          cluster: newVal.cluster || [],
          area: newVal.area || [],
          minScore: newVal.minScore || 0,
          skills: newVal.skills ? [...newVal.skills] : [],
        };
      },
    },
  },
  methods: {
    emitUpdate() {
      this.$emit("update-filters", { ...this.localFilters });
    },
  },
};
</script>

<style scoped>
.search-filters {
  position: sticky;
  top: 16px;
}
.theme-text-secondary {
  color: #666;
}
.v-application.theme--dark .theme-text-secondary {
  color: #aaa;
}
</style>

<style>
.search-filters .v-chip {
  background-color: #E3F2FD !important;
  color: #1565C0 !important;
  border: 1px solid #90CAF9 !important;
}
.search-filters .v-chip .v-chip__close {
  color: #1565C0 !important;
}
.v-application.theme--dark .search-filters .v-chip {
  background-color: #1E3A5F !important;
  color: #90CAF9 !important;
  border: 1px solid #42A5F5 !important;
}
.v-application.theme--dark .search-filters .v-chip .v-chip__close {
  color: #90CAF9 !important;
}
</style>
